module.exports = __webpack_public_path__ + "static/media/human9.04542e10.jpg";